import { SettingsGlobal } from 'entities/Settings/interfaces';
import { Actions } from './actions';
import {
  GET_GLOBAL_SETTINGS_ERROR,
  GET_GLOBAL_SETTINGS_REQUEST,
  GET_GLOBAL_SETTINGS_SUCCESS,
  PUT_GLOBAL_SETTINGS_REQUEST,
  PUT_GLOBAL_SETTINGS_SUCCESS,
  PUT_GLOBAL_SETTINGS_ERROR,
  FORCE_SAVE_GLOBAL_SET,
  SET_SAVE_GLOBAL_SET,
} from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,
  settings: {} as SettingsGlobal,

  savedSet: false,
  forceSaveSet: null as null | string,
};

export type settingsGlobalState = typeof initialState;

export const settingsGlobalReducer = (state: settingsGlobalState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_GLOBAL_SETTINGS_REQUEST: {
      return {
        ...state,
        error: null,
        loading: true,
        forceSaveSet: null,
      };
    }
    case GET_GLOBAL_SETTINGS_SUCCESS: {
      return {
        loading: false,
        error: null,
        settings: action.payload,
        savedSet: true,
        forceSaveSet: null,
      };
    }
    case GET_GLOBAL_SETTINGS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        forceSaveSet: null,
      };
    }

    case PUT_GLOBAL_SETTINGS_REQUEST: {
      return {
        ...state,
        loading: true,
        forceSaveSet: null,
      };
    }
    case PUT_GLOBAL_SETTINGS_SUCCESS: {
      return {
        loading: false,
        error: null,
        settings: {},
        savedSet: true,
        forceSaveSet: null,
      };
    }
    case PUT_GLOBAL_SETTINGS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        savedSet: false,
        forceSaveSet: null,
      };
    }
    case FORCE_SAVE_GLOBAL_SET: {
      return {
        ...state,
        forceSaveSet: action.payload,
      };
    }
    case SET_SAVE_GLOBAL_SET: {
      return {
        ...state,
        savedSet: action.payload,
        forceSaveSet: null,
      };
    }
    default: {
      return state;
    }
  }
};
